import {types} from 'mobx-state-tree';
import moment from 'moment';
import AuthService from '../services/AuthService';
import {rootStore} from '.';
import {moveLoginPage} from "../lib/Util";

function isJSON(str) {
    try {
        return (JSON.parse(str) && !!str);
    } catch (e) {
        return false;
    }
}

export const User = types
    .model('User', {
        id: types.optional(types.number, 0),
        name: types.maybe(types.string),
        // 다국어 이름(외국어 화면 표시용, /auth/me 응답)
        nameEngFirst: types.maybeNull(types.string),
        nameEngLast: types.maybeNull(types.string),
        nameVie: types.maybeNull(types.string),
        nameChn: types.maybeNull(types.string),
        email: types.maybe(types.string),
        gender: types.maybe(types.string),
        profile: types.maybe(types.string),
        phone: types.maybe(types.string),
        userRank: types.maybe(types.string),
        userDepartment: types.maybe(types.string),
        // 직위·부서 번역명(외국어 화면 표시용, /auth/me 응답)
        userRankEng: types.maybeNull(types.string),
        userRankVie: types.maybeNull(types.string),
        userRankChn: types.maybeNull(types.string),
        userDepartmentEng: types.maybeNull(types.string),
        userDepartmentVie: types.maybeNull(types.string),
        userDepartmentChn: types.maybeNull(types.string),
        userDepartmentId: types.maybeNull(types.number),
        loginType: types.maybe(types.string),
        createdAt: types.maybe(types.string),
        udpatedAt: types.maybe(types.string),
        currentCompanyId: types.maybe(types.number),
        permission: types.maybe(types.string),
        permissions: types.frozen(),
        workGubun: types.maybe(types.string),
        userState: types.maybeNull(types.string),
        restType: types.maybeNull(types.boolean, false),
        restDate: types.maybeNull(types.string),
        restOptionYear: types.maybe(types.integer),
        positionName: types.maybe(types.string),
        roleId: types.maybe(types.integer),
        roleName: types.maybe(types.string),
        workSystemId: types.maybe(types.integer),
        workSystemName: types.maybe(types.string),
        joinDate: types.maybeNull(types.string),
        restAccrualTransfer: types.maybeNull(types.boolean, false),
        restAccrualTransferAgree: types.maybeNull(types.boolean, false),
        restTransferAgreeDay: types.maybeNull(types.number),
        restTransferAgreeYn: types.maybeNull(types.boolean, false),
        restAccrualTransferMax: types.maybeNull(types.number),
        restAccrualTransferTarget: types.maybeNull(types.string),
        isClock: types.maybeNull(types.boolean, false),
        strandardHur: types.maybeNull(types.number),
        hireType: types.maybeNull(types.number),
        backGroundImg: types.maybeNull(types.string),
        currentRestYear: types.maybeNull(types.number),
        companyNumber: types.maybeNull(types.string), // 사번
    })
    .views((self) => ({
        get me() {
            try {
                return {
                    ...self,
                    profile: self.profile?.includes('http') ? self?.profile || null : (self.profile ? '//work.pinat.co.kr' + self.profile : null),
                    // permissions: JSON.parse(self.permissions),
                    permissions: isJSON(self.permissions) ? JSON.parse(self.permissions) : self.permissions
                };
            } catch (err) {
                console.error(err);
                return err;
            }
        },
    }))
    .actions((self) => ({
        async authMe() {
            try {
                const response = await AuthService.me();
                if (response.data) {
                    self.setData(response.data);
                    return response.data;
                } else {
                    moveLoginPage();
                }
            } catch (err) {
                moveLoginPage();
            }
        },

        async setRank(rank) {
            self.userRank = rank;
        },

        async setDepartment(depart) {
            self.userDepartment = depart;
        },

        async setDepartmentId(departmentId) {
            self.userDepartmentId = departmentId;
        },

        async setBackGroundImg(backGroundImg) { // 개별로 바꿔야하여 추가
            self.backGroundImg = backGroundImg;
        },

        async setCurrentRestYear(currentRestYear) {
            self.currentRestYear = currentRestYear;
        },

        async setCompanyNumber(companyNumber) {
            self.companyNumber = companyNumber;
        },

        async setData(data) {
            self.id = data?.id || self.id;
            self.name = data?.name || self.name;
            self.nameEngFirst = data?.nameEngFirst || self.nameEngFirst;
            self.nameEngLast = data?.nameEngLast || self.nameEngLast;
            self.nameVie = data?.nameVie || self.nameVie;
            self.nameChn = data?.nameChn || self.nameChn;
            self.email = data?.email || self.email;
            self.gender = data?.gender || self.gender;
            self.profile = data?.profile || self.profile;
            self.phone = data?.phone || self.phone;
            self.userRank = data?.userRank || self.userRank;
            self.userDepartment = data?.userDepartment || ''; // || self.userDepartment;
            self.userRankEng = data?.userRank ? (data?.userRankEng ?? null) : self.userRankEng; // userRank와 같이 갱신
            self.userRankVie = data?.userRank ? (data?.userRankVie ?? null) : self.userRankVie; // userRank와 같이 갱신
            self.userRankChn = data?.userRank ? (data?.userRankChn ?? null) : self.userRankChn; // userRank와 같이 갱신
            self.userDepartmentEng = data?.userDepartmentEng ?? null;
            self.userDepartmentVie = data?.userDepartmentVie ?? null;
            self.userDepartmentChn = data?.userDepartmentChn ?? null;
            self.userDepartmentId = data?.userDepartmentId ?? 0;
            self.loginType = data?.loginType || '';
            self.permissions = data?.permissions || self.permissions;
            self.permission = data?.permission || self.permission;
            self.workGubun = data?.workGubun || self.workGubun;
            self.userState = data?.userState || self.userState;
            self.restType = data?.restType || self.restType;
            self.restDate = data?.restDate || self.restDate;
            self.restOptionYear = data?.restOptionYear || self.restOptionYear;
            self.createdAt = moment(data?.createdAt).format('YYYY-MM-DD HH:mm:ss');
            self.udpatedAt = moment(data?.udpatedAt).format('YYYY-MM-DD HH:mm:ss');
            self.positionName = data?.positionName || self.positionName;
            self.roleId = data?.roleId || self.roleId;
            self.roleName = data?.roleName || self.roleName;
            self.workSystemId = data?.workSystemId || self.workSystemId;
            self.workSystemName = data?.workSystemName || self.workSystemName;
            self.joinDate = moment(data?.joinDate).format('YYYY-MM-DD');
            self.restAccrualTransfer = data?.restAccrualTransfer || self.restAccrualTransfer;
            self.restAccrualTransferAgree = data?.restAccrualTransferAgree || self.restAccrualTransferAgree;
            self.restTransferAgreeDay = data?.restTransferAgreeDay || self.restTransferAgreeDay;
            self.restTransferAgreeYn = data?.restTransferAgreeYn || self.restTransferAgreeYn;
            self.restAccrualTransferMax = data?.restAccrualTransferMax || self.restAccrualTransferMax;
            self.restAccrualTransferTarget = data?.restAccrualTransferTarget || self.restAccrualTransferTarget;
            self.isClock = data?.isClock ?? self.isClock;
            self.strandardHur = data?.strandardHur || self.strandardHur;
            self.hireType = data?.hireType || self.hireType;
            self.backGroundImg = data?.backGroundImg || self.backGroundImg;
            self.currentRestYear = data?.currentRestYear || self.currentRestYear;
            self.companyNumber = data?.companyNumber || self.companyNumber;

            if (data.currentCompanyId) self.currentCompanyId = data?.currentCompanyId;
        },

        async logout() {
            self.id = 0;
            self.name = '';
            self.nameEngFirst = null;
            self.nameEngLast = null;
            self.nameVie = null;
            self.nameChn = null;
            self.email = '';
            self.gender = '';
            self.profile = '';
            self.phone = '';
            self.userRank = '';
            self.userDepartment = '';
            self.userRankEng = null;
            self.userRankVie = null;
            self.userRankChn = null;
            self.userDepartmentEng = null;
            self.userDepartmentVie = null;
            self.userDepartmentChn = null;
            self.userDepartmentId = 0;
            self.loginType = '';
            self.createdAt = '';
            self.udpatedAt = '';
            self.currentCompanyId = 0;
            self.permission = '';
            self.permissions = {};
            self.workGubun = '';
            self.userState = '';
            self.restType = false;
            self.restDate = '';
            self.restOptionYear = 0;
            self.positionName = '';
            self.roleId = 0;
            self.roleName = '';
            self.workSystemId = 0;
            self.workSystemName = '';
            self.joinDate = '';
            self.restAccrualTransfer = false;
            self.restAccrualTransferAgree = false;
            self.restTransferAgreeDay = 0;
            self.restTransferAgreeYn = false;
            self.restAccrualTransferMax = 0;
            self.restAccrualTransferTarget = '';
            self.isClock = false;
            self.strandardHur = 0;
            self.hireType = 0;
            self.backGroundImg = '';
            self.currentRestYear = 0;
            self.companyNumber = '';

            localStorage.removeItem('showAttendancePopup');
            // Reset Attendance data
            rootStore?.attend?.reset();
        },
    }));

export default User;
